<template>
  <div>
    <div>
      <!-- <el-breadcrumb
        separator="/"
        ref="proInfo"
        :model="proInfo"
        @keyup.enter.native="getProList()"
      >
        <el-breadcrumb-item :to="{ path: '/home/production' }"
          >产品信息</el-breadcrumb-item
        >
        <el-breadcrumb-item
          >{{ proInfo.productSeries }}基础版本详情</el-breadcrumb-item
        >
      </el-breadcrumb> -->
      <br />
      <el-descriptions
        class="margin-top"
        title="产品信息"
        :column="2"
        :size="size"
        ref="proInfo"
        :inline="true"
        :model="proInfo"
        @keyup.enter.native="getDataList()"
      >
        <el-descriptions-item label="产品系列" prop="productSeries">{{
          proInfo.productSeries
        }}</el-descriptions-item>
        <el-descriptions-item label="产品编号" prop="productNumber">{{
          proInfo.productNumber
        }}</el-descriptions-item>
        <el-descriptions-item label="产品名称" prop="productName">{{
          proInfo.productName
        }}</el-descriptions-item>
        <el-descriptions-item label="产品运行端" prop="execEnd">{{
          proInfo.execEnd
        }}</el-descriptions-item>
        <el-descriptions-item label="客户名称" prop="userName">{{
          proInfo.userName
        }}</el-descriptions-item>
        <el-descriptions-item
          v-if="perm == 'admin'"
          label="维护用户"
          prop="maintainerUserName"
        >
          <el-popover placement="right" width="200" trigger="click">
            <div class="content">用户名：{{ proInfo.maintainerLoginName }}</div>
            <div class="content">姓名：{{ proInfo.maintainerUserName }}</div>
            <div class="content">备注：{{ proInfo.remark || '-' }}</div>
            <el-button slot="reference" type="text" class="name">{{
              proInfo.maintainerUserName
            }}</el-button>
          </el-popover>
        </el-descriptions-item>
        <el-descriptions-item label="备注" prop="note">
          {{ proInfo.note || '-' }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="box2">
      <!-- <el-page-header content="版本管理"></el-page-header> -->
      <el-form
        ref="dataForm"
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item label="发布时间" prop="dateTime">
          <el-date-picker
            v-model="dataForm.dateTime"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="
              pageIndex = 1
              getDataList(true)
            "
            >查询</el-button
          >
          <el-button @click="refreshForm()">重置</el-button>
        </el-form-item>
        <el-button
          class="pull-right"
          v-if="perm !== 'admin'"
          type="primary"
          @click="uploadModal(proInfo)"
        >
          <i class="el-icon-plus"></i>
          新版本
        </el-button>
      </el-form>

      <el-table
        :data="dataList"
        v-loading="tabLoding"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="versionNumber"
          header-align="center"
          align="center"
          label="版本号"
        >
        </el-table-column>
        <el-table-column
          prop="forceUpdate"
          header-align="center"
          align="center"
          label="强制升级"
        >
          <template slot-scope="scope">{{
            scope.row.forceUpdate | isOrNot
          }}</template>
        </el-table-column>
        <el-table-column
          prop="createtime"
          header-align="center"
          align="center"
          width="180px"
          label="创建时间"
        >
          <template slot-scope="scope"
            >{{ scope.row.createtime || '-' }}
          </template>
        </el-table-column>

        <el-table-column
          prop="validTime"
          header-align="center"
          align="center"
          width="180px"
          label="发布时间"
        >
          <template slot-scope="scope"
            ><span v-if="scope.row.versionType === 2">{{
              scope.row.validTime
            }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <!-- 1：测试版，2：正式版 -->
        <el-table-column
          prop="versionType"
          header-align="center"
          align="center"
          width="180px"
          label="版本类型"
        >
          <template slot-scope="scope"
            ><span>{{ scope.row.versionType | versionType }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          header-align="center"
          align="center"
          label="状态"
        >
          <template slot-scope="scope">
            <span>
              <!-- 待发布的要展示一下待发布的时间 -->
              <span v-if="scope.row.status === 3">{{
                scope.row.validTime
              }}</span>
              {{ scope.row.status | status }}</span
            ></template
          >
        </el-table-column>
        <el-table-column
          fixed="right"
          header-align="center"
          align="center"
          width="250"
          label="操作"
        >
          <template slot-scope="scope">
            <span v-if="perm === 'admin'">
              <el-button type="text" size="small" @click="dwCode(scope.row)"
                >二维码</el-button
              >

              <el-button type="text" size="small" @click="details(scope.row)"
                >查看详情</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="versionRemark(scope.row)"
                >版本备注</el-button
              >
            </span>
            <span v-if="perm !== 'admin'">
              <!-- 已下线不可以编辑和删除 -->
              <el-button
                v-if="scope.row.status !== 5"
                type="text"
                size="small"
                @click="editVersion(scope.row)"
                >编辑</el-button
              >
              <!-- 待测试和测试中的能删除 -->
              <el-button
                v-if="scope.row.status === 1 || scope.row.status === 2"
                type="text"
                size="small"
                @click="deleteVersion(scope.row.id)"
                >删除</el-button
              >
              <el-button
                v-if="scope.row.status === 1 || scope.row.status === 0"
                type="text"
                size="small"
                @click="startTest(scope.row.id)"
                >启动测试</el-button
              >
              <el-button
                v-if="scope.row.status === 2"
                type="text"
                size="small"
                @click="releaseVersion(scope.row)"
                >确认发布</el-button
              >
              <el-button
                v-if="scope.row.status === 3"
                type="text"
                size="small"
                @click="stopRelease(scope.row.id)"
                >停止发布</el-button
              >
              <el-button
                v-if="scope.row.status === 4"
                type="text"
                size="small"
                @click="offlineVersion(scope.row.id)"
                >下线</el-button
              >
              <el-popover placement="right" width="180" trigger="click">
                <span class="content"
                  ><el-button
                    type="text"
                    size="small"
                    @click="dwCode(scope.row)"
                    >二维码</el-button
                  ></span
                >
                <span class="content">
                  <el-button
                    type="text"
                    size="small"
                    @click="details(scope.row)"
                    >查看详情</el-button
                  ></span
                >
                <span class="content">
                  <el-button
                    type="text"
                    size="small"
                    @click="versionRemark(scope.row)"
                    >版本备注</el-button
                  ></span
                >
                <el-button
                  v-if="perm !== 'admin'"
                  slot="reference"
                  type="text"
                  class="name more-action"
                  >更多<i class="el-icon-d-arrow-right"></i
                ></el-button>
              </el-popover>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="totalPage > 0">
        <el-pagination
          class="mt-sm"
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="totalPage"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
      <version-remark
        v-if="remarkVisible"
        ref="updateInfo"
        @refreshDataList="getDataList"
      ></version-remark>
      <edit-version
        v-if="editVisible"
        ref="editInfo"
        @refreshDataList="getDataList"
      ></edit-version>
    </div>
    <release-version
      v-if="releaseVisible"
      ref="releaseInfo"
      @refreshDataList="getDataList"
      :productId="proInfo.id"
    ></release-version>
    <upload-modal
      v-if="uploadVisible"
      ref="uploadModal"
      @refreshDataList="getDataList"
      :vstatus="status"
      :productId="proInfo.id"
      :productNumber="proInfo.productNumber"
      :productName="proInfo.productName"
      :productType="proInfo.productSeries"
    ></upload-modal>
    <el-dialog
      title="提示"
      class="dw-box"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dwVisible"
      width="400px"
    >
      <p class="dflex">
        <i class="el-icon-warning dw-sure"></i>确定下载当前安装包吗？
      </p>
      <p v-if="percentFlag">
        <el-progress
          class="percent-progress"
          :percentage="downProgress"
        ></el-progress>
        <span class="font-gray">正在下载</span>
      </p>

      <span slot="footer" class="dialog-footer">
        <el-button
          class="el-button--small"
          :loading="dwloading"
          @click="dwVisible = false"
          >取 消</el-button
        >
        <el-button
          class="el-button--small"
          :loading="dwloading"
          type="primary"
          @click="downloadSureOK"
          >下 载</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="二维码"
      :visible.sync="codeVisible"
      width="400px"
      :before-close="codeClose"
    >
      <div class="text-center">
        <p class="qrcodeurl">{{ qrcodeurl }}</p>

        <canvas id="QRCode_box"></canvas>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import encryption from '../../utils/encryption.js'
import httpMethods from '@/api/version/http.js'
import VersionRemark from './components/VersionRemark.vue'
import UploadModal from './components/UploadModal.vue'
import ReleaseVersion from './components/ReleaseVersion.vue'
import bus from './../../utils/bus'
import QRCode from 'qrcode'
export default {
  data() {
    return {
      waitTestVersionInfo: null, // 待测试的版本是否存在
      publickey: '', // sm2获取的公钥
      time: '', // sm2获取的时间戳
      qrcodeurl: '',
      size: '',
      versionId: '', //  sm2加密后的版本Id
      productId: '', //  sm2加密后的产品Id
      dwVisible: false,
      dwloading: false,
      downProgress: 0,
      percentFlag: false,
      currentVersion: '',
      codeVisible: false,
      editVisible: false,
      releaseVisible: false,
      productVisible: false,
      visible: false,
      exitTesting: false, // 是否存在测试中的版本
      QRImgUrl: '',
      status: '',
      proInfo: {
        id: '',
        productSeries: '',
        type: '',
        productNumber: '',
        execEnd: '',
        productName: '',
        userName: '',
        remark: '',
        dateTime: '',
        maintainerLoginName: '',
        maintainerUserName: '',
        maintainerId: '',
        versionremark: '',
        describe: ''
      },
      dataForm: {
        dateTime: ''
      },
      tabLoding: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      uploadVisible: false, // 安装包上传
      remarkVisible: false, // 版本备注查看
      isOrNot: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 1,
          label: '是'
        },
        {
          value: 0,
          label: '否'
        }
      ],
      typeOptions: [],
      terminals: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  computed: {
    username() {
      return this.$store.state.username
    },
    perm() {
      return this.$store.state.perm
    }
  },
  components: {
    UploadModal,
    VersionRemark,
    ReleaseVersion
  },
  mounted() {
    const search = location.href.split('?id=')[1]
    this.currentId = search.split('&proName=')[0]
    if (this.currentId) {
      this.getDataList()
      this.getProInfo()
      // this.getKeys()
    }
    bus.$on('refreshVersionList', (res) => {
      this.getDataList()
    })
  },
  methods: {
    formatDate(row, column) {
      // 获取单元格数据
      const data = row[column.property]
      if (data == null) {
        return null
      }
      const dt = new Date(data)
      const time =
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      return time
    },
    // 获取产品信息
    getProInfo() {
      this.$http({
        url: this.$http.adornUrl('/api/app/getProductInfoMultiLanguage'),
        method: 'get',
        params: this.$http.adornParams({
          id: this.currentId
        })
      })
        .then((res) => {
          const data = res.data
          if (data && res.resp_code === 0) {
            this.proInfo = res.data
          }
        })
        .catch(() => {})
    },
    getDataList() {
      this.tabLoding = true
      this.$http({
        url: this.$http.adornUrl('/api/app/getProductVersion'),
        method: 'get',
        params: this.$http.adornParams({
          pageNum: this.pageIndex,
          pageSize: this.pageSize,
          productId: this.currentId,
          validTimeStart: this.dataForm.dateTime
            ? this.dataForm.dateTime[0]
            : '',
          validTimeEnd: this.dataForm.dateTime ? this.dataForm.dateTime[1] : ''
        })
      })
        .then((res) => {
          if (res.resp_code === 0) {
            if (res.data.list.length === 0 && res.data.total > 0) {
              this.queryParams.pageNum--
              this.getDataList()
            } else {
              const data = res.data.list || []
              this.dataList = data
              this.totalPage = res.data.total
            }
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.tabLoding = false
        })
        .catch(() => {
          this.dataList = []
          this.totalPage = 0
          this.tabLoding = false
        })
    },
    refreshForm() {
      this.$refs.dataForm.resetFields()
      this.dataForm.force = ''
      this.pageIndex = 1
      this.getDataList()
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 弹出新版本模态页
    openAddVersionModal(info) {
      this.status = 'add'
      this.uploadVisible = true
      this.$nextTick(() => {
        this.$refs.uploadModal.init(info)
      })
    },
    // 上传安装包 +新版本
    uploadModal(info) {
      this.$http
        .all([this.exitsWaitTesting()])
        .then(
          this.$http.spread((res1) => {
            if (res1.resp_code === 0) {
              this.waitTestVersionInfo = res1.data
            }
          })
        )
        .then(() => {
          if (this.waitTestVersionInfo !== null) {
            // 有待测试的版本
            this.addVersionConfirm(info)
          } else {
            this.openAddVersionModal(info)
          }
        })
    },
    addVersionConfirm(info) {
      this.$confirm(
        '该产品下存在未开启测试的版本，再次创建新版本会导致其被删除无法找回，继续操作吗?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.openAddVersionModal(info)
        })
        .catch(() => {})
    },
    // 新增版本的时候，判断是否有未开启测试的版本，如果有，需要先把原来的待测试版本删掉
    exitsWaitTesting() {
      return this.$http({
        url: this.$http.adornUrl('/api/app/getProductVersionWaitTest'),
        method: 'get',
        params: this.$http.adornParams({
          productId: this.currentId
        })
      })
    },

    // 二维码弹框
    dwCode(info) {
      this.currentVersion = info
      this.codeVisible = true
      this.$nextTick(() => {
        this.getQRCode()
      })
    },
    getQRCode() {
      const opts = {
        errorCorrectionLevel: 'H', // 容错级别
        type: 'image/png', // 生成的二维码类型
        quality: 0.3, // 二维码质量
        margin: 12, // 二维码留白边距
        width: 200, // 宽
        height: 180, // 高
        color: {
          dark: '#333333', // 前景色
          light: '#fff' // 背景色
        }
      }
      // const sm2 = require('sm-crypto').sm2
      // const cipherMode = 1 // 1 - C1C3C2，0 - C1C2C3，默认为1
      // this.versionId = sm2.doEncrypt(
      //   this.currentVersion.id,
      //   this.publickey,
      //   cipherMode
      // ) // sm2加密
      // this.productId = sm2.doEncrypt(
      //   this.proInfo.id,
      //   this.publickey,
      //   cipherMode
      // ) // sm2加密
      // 加密
      this.productId = encryption.Encrypt(this.proInfo.id)
      this.versionId = encryption.Encrypt(this.currentVersion.id)
      this.qrcodeurl =
        location.origin +
        '/#/productload?productId=' +
        encodeURIComponent(this.productId) +
        '&versionId=' +
        encodeURIComponent(this.versionId) // 生成的二维码为URL地址js
      const msg = document.getElementById('QRCode_box')
      QRCode.toCanvas(msg, this.qrcodeurl, opts)
    },
    codeClose() {
      this.codeVisible = false
    },
    // 获取sm2的公钥和时间戳
    // getKeys() {
    //   httpMethods
    //     .keys()
    //     .then((res) => {
    //       this.loading = false
    //       const data = res.data
    //       if (data && res.resp_code === 0) {
    //         this.publickey = '04' + res.data.PublicKey
    //         this.time = res.data.time
    //       } else {
    //         this.publickey = ''
    //         this.time = ''
    //         this.$message.error(res.resp_msg)
    //       }
    //     })
    //     .catch(() => {})
    // },
    // 下载
    downloadSureOK() {
      this.dwVisible = false
      window.location.href = `/api/api/app/download/${this.currentVersion.id}/${this.currentVersion.versionNumber}`
    },
    downloadSure() {
      const that = this
      this.dwloading = true
      this.percentFlag = true
      this.$http({
        url: this.$http.adornUrl(
          `/api/app/download/${this.currentVersion.productNumber}/${this.currentVersion.versionNumber}`
        ),
        method: 'get',
        responseType: 'blob',
        onDownloadProgress(progress) {
          that.downProgress = Math.round(
            (100 * progress.loaded) / progress.total
          )
          if (that.downProgress === 100) {
            that.percentFlag = false
          }
        }
      }).then((res) => {
        this.dwloading = false
        this.dwVisible = false
        this.percentFlag = false
        const content = res.data
        const blob = new Blob([content])
        const fileName = this.currentVersion.fileName
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    download(info) {
      this.currentVersion = info
      this.dwVisible = true
      if (!this.percentFlag) {
        this.downProgress = 0
      }
    },
    // 版本备注
    versionRemark(info) {
      this.remarkVisible = true
      this.$nextTick(() => {
        this.$refs.updateInfo.init(info)
      })
    },
    editVersion(versionInfo) {
      this.status = 'edit'
      this.uploadVisible = true
      this.$nextTick(() => {
        this.$refs.uploadModal.init(versionInfo, this.proInfo.appMarketLink)
      })
    },
    releaseVersion(info) {
      this.releaseVisible = true
      this.$nextTick(() => {
        this.$refs.releaseInfo.init(info)
      })
    },

    // 查看详情
    details(info) {
      this.productId = encryption.Encrypt(this.proInfo.id)
      this.versionId = encryption.Encrypt(info.id)

      // this.getKeys()
      // const sm2 = require('sm-crypto').sm2
      // const cipherMode = 0 // 1 - C1C3C2，0 - C1C2C3，默认为1
      // this.versionId = sm2.doEncrypt(info.id, this.publickey, cipherMode) // sm2加密
      // this.productId = sm2.doEncrypt(
      //   this.proInfo.id,
      //   this.publickey,
      //   cipherMode
      // ) // sm2加密
      // 加密后的链接
      const detailUrl =
        location.origin +
        '/#/productload?productId=' +
        encodeURIComponent(this.productId) +
        '&versionId=' +
        encodeURIComponent(this.versionId)
      window.open(detailUrl)
    },
    // 删除版本
    deleteVersion(id) {
      this.$confirm('确定进行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteSure(id)
        })
        .catch(() => {})
    },
    deleteSure(id) {
      this.$http({
        url: this.$http.adornUrl('/api/app/deleteProductVersion'),
        method: 'delete',
        params: this.$http.adornParams({
          id: id
        })
      }).then((res) => {
        if (res.resp_code === 0) {
          this.getDataList()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        } else {
          this.$message.error(res.resp_msg || '操作失败')
        }
      })
    },
    getTestingStatus() {
      return this.$http({
        url: this.$http.adornUrl('/api/app/getProductVersionTest'),
        method: 'get',
        params: this.$http.adornParams({
          productId: this.currentId
        })
      })
    },
    // 开启测试按钮
    startTest(id) {
      let showMsg = ''
      this.$http
        .all([this.getTestingStatus()])
        .then(
          this.$http.spread((res1) => {
            if (res1.resp_code === 0) {
              this.exitTesting = res1.data
            }
          })
        )
        .then(() => {
          if (this.exitTesting) {
            // 如果存在测试中的安装包，需要提示
            showMsg =
              '该产品下存在其他测试中的版本，当前操作会导致其被删除无法找回，继续操作吗？'
          } else {
            showMsg = '确认启动测试吗？' // 不存在测试中的安装包
          }
          this.confirmVersion(showMsg, id)
        })
    },
    // 启动测试确认弹框
    confirmVersion(showMsg, id) {
      this.$confirm(showMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.startTestSure(id)
        })
        .catch(() => {})
    },
    // 确认开启测试
    startTestSure(id) {
      this.$http({
        url: this.$http.adornUrl('/api/app/statusConvert'),
        method: 'post',
        data: this.$http.adornData({
          status: 1, // 待测试
          id: id,
          returnTest: 0
        })
      }).then((res) => {
        if (res.resp_code === 0) {
          this.getDataList()
          this.$message({
            message: '开启测试成功',
            type: 'success'
          })
        } else {
          this.$message.error(res.resp_msg || '操作失败')
        }
      })
    },
    // 停止发布
    stopRelease(id) {
      this.$confirm('确定停止发布?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.stopReleaseSure(id)
        })
        .catch(() => {})
    },
    // 确认停止发布
    stopReleaseSure(id) {
      const data = {
        status: 3, // 待发布
        id: id,
        returnTest: 1 // 停止发布
      }
      httpMethods
        .updateVersionState(data)
        .then((res) => {
          if (data && res.resp_code === 0) {
            this.$message.success('停止发布成功')
            this.getDataList()
          } else {
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {})
    },
    // 下线
    offlineVersion(id) {
      this.$confirm('确认下线?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.offlineVersionSure(id)
        })
        .catch(() => {})
    },
    offlineVersionSure(id) {
      const data = {
        status: 4, // 已发布
        id: id,
        returnTest: 0 // 非停止发布
      }
      httpMethods
        .updateVersionState(data)
        .then((res) => {
          if (data && res.resp_code === 0) {
            this.$message.success('下线成功')
            this.getDataList()
          } else {
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.more-action {
  font-size: 12px;
  margin-left: 10px;
}
::v-deep {
  .el-page-header__left {
    display: none;
  }
  .dw-box .el-dialog__body {
    padding: 0 20px;
  }
  .el-descriptions-item__container {
    height: 21px !important;
  }
}
.valid-status {
  color: #67c23a;
}
.unvalid-status {
  color: #f56c6c;
}
.dw-sure {
  font-size: 20px;
  margin-right: 20px;
  color: #e6a23c;
}
.dflex {
  display: flex;
}
.percent-progress {
  margin: 10px 0;
}
.font-gray {
  font-size: 12px;
  color: #999;
}
.text-center {
  text-align: center;
  .qrcodeurl {
    text-align: left;
  }
}
.box2 {
  padding: 20px 0;
}
.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
  color: #67c23a !important;
}
.name {
  margin-top: -9px !important;
}
.content {
  line-height: 24px;
  margin-left: 10px;
}
</style>
